import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { ADDABLE_KINDS, NODE_KINDS } from './nodeKinds';
import { NodeMark } from './EvalNode';

/**
 * Pick the kind of step to insert. Opens over the canvas; the caller knows
 * WHERE the step goes (which edge) — this only asks WHAT it is.
 *
 * A name and its mark, nothing else: the list is six items a person picks
 * from in a second, and a sentence under each turned that into reading.
 */
export default function Palette({ open, onPick, onClose, title = 'Add a step' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-start justify-center bg-[color:var(--surface-overlay)] px-4 pt-[14vh]" onMouseDown={onClose} role="dialog" aria-modal="true" aria-label={title} style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* The same shell as the app's other popups (search, the filter popup): raised surface, 10px radius, the large shadow. */}
      <div className="w-full max-w-[400px] overflow-hidden rounded-[10px] border border-[color:var(--border-default)] bg-[color:var(--surface-raised)]" style={{ boxShadow: 'var(--shadow-lg)' }} onMouseDown={(e) => e.stopPropagation()}>
        <div className="flex h-10 items-center justify-between border-b border-[color:var(--border-default)] px-3">
          <div className="text-[12.5px] font-semibold text-[color:var(--text-primary)]">{title}</div>
          <button type="button" onClick={onClose} aria-label="Close" className="rounded-md p-1 text-[color:var(--text-muted)] transition-colors hover:bg-surface-hover hover:text-[color:var(--text-primary)]"><X size={14} /></button>
        </div>
        <div className="p-1.5">
          {ADDABLE_KINDS.map((k) => {
            const m = NODE_KINDS[k];
            return (
              <button key={k} type="button" onClick={() => onPick(k)} className="flex h-9 w-full items-center gap-2.5 rounded-md px-2.5 text-left transition-colors hover:bg-surface-hover">
                <NodeMark kind={k} size={22} />
                <span className="truncate text-[12.5px] font-medium text-[color:var(--text-primary)]">{m.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
